import { keys } from 'ramda';

import { CompactCondition, ConditionGroups } from '../config';

type ConditionItemsByGroupsType = Record<ConditionGroups, CompactCondition[]>;

export const useConditionGroupsList = (
  conditionItemsByGroups: ConditionItemsByGroupsType,
  openAll?: boolean,
) => {
  const filteredConditionItemsByGroups = Object.entries(
    conditionItemsByGroups,
  ).reduce((result, [group, items]) => {
    if (items.length > 0) {
      result[group as keyof ConditionItemsByGroupsType] = items;
    }

    return result;
  }, {} as Partial<ConditionItemsByGroupsType>);

  const conditionGroupsList = keys(filteredConditionItemsByGroups);

  const openConditionGroups = openAll
    ? conditionGroupsList
    : conditionGroupsList.filter((group) =>
        (filteredConditionItemsByGroups[group] ?? []).some(
          (item) => item.isChecked,
        ),
      );

  return { conditionGroupsList, openConditionGroups };
};
